if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function(){

    /*
        HOME ARROW
        $('.arrow-home').click(function(event) {
            $('body, html').animate({
                scrollTop: $(window).height()-$('header').outerHeight()*2},
                800, 'easeOutExpo');
        });
    */

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));


    $('.sym-slides').slick({
        accessibility: false
    });

    $('.press-carousel__content--items').slick({
        accessibility: false,
        appendArrows: '.press-carousel__arrows',
        prevArrow:"<button type='button' class='slick-prev'>Prev</button>",
        fade:true
    });
    $('.properties-filter__content').slick({
        accessibility: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        fade:true
    });
    $('.js-prop-selector').on('click', function(e){
        e.preventDefault();
        var slideNo = $(this).data('slide');
        $('.properties-filter__content').slick('slickGoTo', slideNo);
        $(this).parent().addClass('active');
        $(this).parent().siblings().removeClass('active'); 
    })

    $('.properties-filter__selector--select').on('change', function(e){
        e.preventDefault();
        var slideNo = $(this).val();
        $('.properties-filter__content').slick('slickGoTo', slideNo);
    })


})();